'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.insertSubIntoProp = exports.prependSubToProp = exports.appendSubToProp = exports.extractFunctionArguments = exports.replaceTokens = exports.replaceToken = exports.wrapWithSingleQuotes = exports.wrapWith = exports.splitOnColon = exports.splitCamelcase = exports.splitOnComma = exports.splitOnUnnestedComma = exports.splitOnUnnestedWhitespace = exports.splitOnWhitespace = exports.toKebabCase = exports.firstToUpper = exports.joinWithDoubleNewlines = exports.joinWithPipe = exports.joinWithNewline = exports.joinWithDot = exports.joinWithNoSpace = exports.joinWithHypen = exports.joinWithCommaSpace = exports.joinWithComma = exports.joinWithSpace = exports.indentLines = exports.printObj = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _dasherize = require('dasherize');

var _dasherize2 = _interopRequireDefault(_dasherize);

var _ramda = require('ramda');

var _ramdaAdjunct = require('ramda-adjunct');

var _regexp = require('../const/regexp');

var _functions = require('./functions');

var _objects = require('./objects');

var _predicate = require('./predicate');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// -----------------------------------------------------------------------------
// Chars
// -----------------------------------------------------------------------------

var NEWLINE = '\n';
var DOUBLE_NEWLINE = '' + NEWLINE + NEWLINE;
var SPACE = ' ';
var COMMA = ',';
var COLON = ':';
var HYPHEN = '-';
var FULL_STOP = '.';
var SINGLE_QUOTE = '\'';
var PIPE = '|';
var COMMA_SPACE = '' + COMMA + SPACE;

// -----------------------------------------------------------------------------
// Create
// -----------------------------------------------------------------------------

var toToken = function toToken(v) {
  return new RegExp('#{(' + v + ')}', 'g');
};

// -----------------------------------------------------------------------------
// Print
// -----------------------------------------------------------------------------

var printObj = exports.printObj = JSON.stringify;

// -----------------------------------------------------------------------------
// Indent
// -----------------------------------------------------------------------------

var indentLines = exports.indentLines = (0, _ramda.replace)(_regexp.RE_START_OF_LINE, '  ');

// -----------------------------------------------------------------------------
// Join
// -----------------------------------------------------------------------------

var joinWithSpace = exports.joinWithSpace = (0, _ramda.join)(SPACE);

var joinWithComma = exports.joinWithComma = (0, _ramda.join)(COMMA);

var joinWithCommaSpace = exports.joinWithCommaSpace = (0, _ramda.join)(COMMA_SPACE);

var joinWithHypen = exports.joinWithHypen = (0, _ramda.join)(HYPHEN);

var joinWithNoSpace = exports.joinWithNoSpace = (0, _ramda.join)('');

var joinWithDot = exports.joinWithDot = (0, _ramda.join)(FULL_STOP);

var joinWithNewline = exports.joinWithNewline = (0, _ramda.join)(NEWLINE);

var joinWithPipe = exports.joinWithPipe = (0, _ramda.join)(PIPE);

var joinWithDoubleNewlines = exports.joinWithDoubleNewlines = (0, _ramda.join)(DOUBLE_NEWLINE);

// -----------------------------------------------------------------------------
// Case
// -----------------------------------------------------------------------------

var firstToUpper = exports.firstToUpper = (0, _ramda.compose)(joinWithNoSpace, (0, _ramda.over)((0, _ramda.lensIndex)(0), _ramda.toUpper));

var toKebabCase = exports.toKebabCase = _dasherize2.default;

// -----------------------------------------------------------------------------
// Split
// -----------------------------------------------------------------------------

var splitOnWhitespace = exports.splitOnWhitespace = (0, _ramda.split)(_regexp.RE_WHITESPACE);

var splitOnUnnestedWhitespace = exports.splitOnUnnestedWhitespace = (0, _ramda.split)(_regexp.RE_UNNESTED_WHITESPACE);

var splitOnUnnestedComma = exports.splitOnUnnestedComma = (0, _ramda.split)(_regexp.RE_UNNESTED_COMMA);

var splitOnComma = exports.splitOnComma = (0, _ramda.split)(COMMA);

var splitCamelcase = exports.splitCamelcase = (0, _ramda.compose)((0, _ramda.split)(' '), (0, _ramda.replace)(_regexp.RE_CAPITAL_LETTERS, ' $1'));

var splitOnColon = exports.splitOnColon = (0, _ramda.split)(COLON);

// -----------------------------------------------------------------------------
// Wrap
// -----------------------------------------------------------------------------

var wrapWith = exports.wrapWith = function wrapWith(a) {
  var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : a;
  return (0, _ramda.compose)(joinWithNoSpace, (0, _ramda.prepend)(a), (0, _ramda.append)(b), String);
};

var wrapWithSingleQuotes = exports.wrapWithSingleQuotes = wrapWith(SINGLE_QUOTE);

// -----------------------------------------------------------------------------
// Replace
// -----------------------------------------------------------------------------

var replaceToken = exports.replaceToken = (0, _ramda.curry)(function (template, tokenName, value) {
  return (0, _ramda.replace)(toToken(tokenName), value, template);
});

var replaceWithMap = (0, _ramda.curry)(function (template, valueMap) {
  return (0, _objects.reduceObjIndexed)(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return replaceToken(acc, key, value);
  }, template, valueMap);
});

var replaceWithArray = (0, _ramda.curry)(function (template, values) {
  return (0, _ramda.pipe)((0, _ramdaAdjunct.reduceIndexed)(function (acc, v, idx) {
    return (0, _ramda.assoc)((0, _ramda.inc)(idx), v, acc);
  }, {}), replaceWithMap(template))(values);
});

var replaceTokens = exports.replaceTokens = (0, _ramda.curry)(function (template, value) {
  return (0, _functions.condDefault)([[_ramdaAdjunct.isArray, replaceWithArray(template)], [_ramdaAdjunct.isPlainObj, replaceWithMap(template)]])(value);
});

// -----------------------------------------------------------------------------
// Extract
// -----------------------------------------------------------------------------

var extractFunctionArguments = exports.extractFunctionArguments = function extractFunctionArguments(value) {
  var parts = new RegExp(_regexp.RE_ARGUMENTS_OF_CSS_FUNCTION).exec(value);
  return (0, _ramda.nth)(1, parts);
};

// -----------------------------------------------------------------------------
// Insert / Append / Prepend
// -----------------------------------------------------------------------------

var appendSubToProp = exports.appendSubToProp = function appendSubToProp(v) {
  return (0, _ramda.compose)(joinWithNoSpace, _ramda.flatten, (0, _ramda.when)((0, _predicate.isLengthGt)(1), (0, _ramda.converge)(_ramdaAdjunct.list, [_ramda.head, (0, _ramda.compose)((0, _ramda.map)(firstToUpper), _ramda.tail)])), _ramdaAdjunct.compact)(v);
};

var prependSubToProp = exports.prependSubToProp = (0, _ramda.compose)(appendSubToProp, _ramda.reverse);

var insertSubIntoProp = exports.insertSubIntoProp = (0, _ramda.compose)((0, _ramda.converge)((0, _ramda.compose)(appendSubToProp, (0, _ramda.insert)(1)), [_ramda.head, (0, _ramda.compose)(splitCamelcase, joinWithNoSpace, _ramda.tail)]), _ramda.reverse);


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/utils/formatting.js
// module id = 13
// module chunks = 168707334958949